import type { PropsWithChildren } from "react";

import { Typography } from "@aircall/tractor";

import type { PlaygroundSubSectionTitleProps } from ".";

export function PlaygroundSubSectionTitle({
  children,
  ...props
}: PropsWithChildren<PlaygroundSubSectionTitleProps>) {
  return (
    <Typography variant="headingMediumXS" {...props}>
      {children}
    </Typography>
  );
}
